import fund1 from '../images/funds-png/save-children.png';
import fund1x from '../images/funds-png/save-children-2x.png';
import fund2 from '../images/funds-png/project-hope.png';
import fund2x from '../images/funds-png/project-hope-2x.png';
import fund3 from '../images/funds-png/united24.png';
import fund3x from '../images/funds-png/united24-2x.png';
import fund4 from '../images/funds-png/international-medical-corps.png';
import fund4x from '../images/funds-png/international-medical-corps-2x.png';
import fund5 from '../images/funds-png/medicins-sans-frontiers.png';
import fund5x from '../images/funds-png/medicins-sans-frontiers-2x.png';
import fund6 from '../images/funds-png/razom.png';
import fund6x from '../images/funds-png/razom-2x.png';
import fund7 from '../images/funds-png/action-against-hunger.png';
import fund7x from '../images/funds-png/action-against-hunger-2x.png';
import fund8 from '../images/funds-png/world-vision.png';
import fund8x from '../images/funds-png/world-vision-2x.png';
import fund9 from '../images/funds-png/sergiy-prytula.png';
import fund9x from '../images/funds-png/sergiy-prytula-2x.png';

export const fundList = [
    {
      title: 'Save the Children',
      url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
      img: fund1,
      retinaImg: fund1x,
    },
    {
      title: 'Project HOPE',
      url: 'https://www.projecthope.org/country/ukraine/',
      img: fund2,
      retinaImg: fund2x,
    },
    {
      title: 'UNITED24',
      url: 'https://u24.gov.ua/uk',
      img: fund3,
      retinaImg: fund3x,
    },
    {
      title: 'International Medical Corps',
      url: 'https://internationalmedicalcorps.org/country/ukraine/',
      img: fund4,
      retinaImg: fund4x,    
    },
    {
      title: 'Medicins Sans Frontieres',
      url: 'https://www.msf.org/ukraine',
      img: fund5,
      retinaImg: fund5x,
    },
    {
      title: 'RAZOM',
      url: 'https://www.razomforukraine.org/',
      img: fund6,
      retinaImg: fund6x,    
    },
    {
      title: 'Action against hunger',
      url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
      img: fund7,
      retinaImg: fund7x,   
    },
    {
      title: 'World vision',
      url: 'https://www.wvi.org/emergencies/ukraine',
      img: fund8,
      retinaImg: fund8x,
    },
    {
      title: 'Serhiy Prytula Charity Foundation',
      url: 'https://prytulafoundation.org/en',
      img: fund9,
      retinaImg: fund9x,
    },
  ];